import { useQueryClient } from '@tanstack/react-query';
import { useReconcileFreeSubscription } from '@/shared/api/generated/subscriptions';
import { getGetCurrentUserQueryKey } from '@/shared/api/generated/current-user';

export const useReconcileFree = () => {
  const queryClient = useQueryClient();
  return useReconcileFreeSubscription({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getGetCurrentUserQueryKey() });
      },
    },
  });
};
